module.exports = __webpack_public_path__ + "1bca915d3f55da73ef92d01e2c684058.jpg";